import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotate, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Button, Form } from '@domain-group/suit-theme'

import { UseInvoiceItemPayload } from '@hooks/useInvoiceItem'

import { confirmDelete } from '@functions/entity'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useInvoiceItemActions from '../hooks/useInvoiceItemActions'

interface ActionsProps {
  callbacks: {
    closeModal: () => void,
    reprocessInvoiceItemToZuora: (payload: HandleCallbackActionParams) => void,
  },
  invoiceItemPayload: UseInvoiceItemPayload,
  isAdmin: boolean,
}

const Actions = (props: ActionsProps) => {
  const { callbacks, invoiceItemPayload, isAdmin } = props
  const { closeModal, reprocessInvoiceItemToZuora } = callbacks || {}

  const {
    callbacks: {
      deleteInvoiceItem: deleteFn,
      reprocessInvoiceItemToZuora: reprocessFn,
    },
    deleting,
    invoice,
    invoiceItem,
    updating,
  } = invoiceItemPayload

  const reprocessInvoiceItemToZuoraPayload = {
    callbacks: {
      action: reprocessFn,
      afterAction: closeModal,
    },
    toastText: 'Invoice Item Reprocessed',
  }

  const confirmDeleteParams = {
    callbacks: {
      deleteFn,
      afterAction: closeModal,
    },
    strings: {
      entityName: 'Invoice Item',
      toastText: 'Deletion Queued',
    },
  }

  const canReprocessToZuora = isAdmin && !!invoiceItem?.billing_type_id && !invoiceItem?.zuora_usage_id

  // Setup realtime subscription
  useInvoiceItemActions(invoiceItem, { callbacks })

  if (!canReprocessToZuora && invoice.approved){
    return null
  }

  return (
    <Form.Field label="More Options" marginTop="large">
      {!invoice.approved && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faTrashAlt} />}
          loading={deleting}
          onClick={() => confirmDelete(confirmDeleteParams)}
          size="medium"
        >
          Delete Item
        </Button>
      )}

      {canReprocessToZuora && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faRotate} />}
          loading={updating}
          marginTop="medium"
          onClick={() => reprocessInvoiceItemToZuora(reprocessInvoiceItemToZuoraPayload)}
          size="medium"
        >
          Reprocess to Zuora
        </Button>
      )}
    </Form.Field>
  )
}

export default Actions
